// Admin → Assistant → « Retouches (essai) » (pages/admin/assistant/EditShadowTab.tsx).
const m: Record<string, string> = {
  'Retouches (essai)': 'Edits (trial)',
  'Retouches d’album — essai de Claude': 'Album edits — Claude trial',
  'Pour chaque demande de retouche, Claude fait le travail sur une copie de l’album et vérifie son résultat. Rien n’est envoyé au client et l’album ne change pas. Dites si c’est juste : quand il a raison presque à chaque fois, il pourra faire les retouches lui-même après votre OK.':
    'For every edit request, Claude does the work on a copy of the album and checks its result. Nothing is sent to the client and the album does not change. Say if it is right: once it is right almost every time, it can do edits itself after your OK.',
  'justes': 'right',
  'Chargement…': 'Loading…',
  'Pas encore d’essai. Le prochain message de retouche d’un client apparaîtra ici.': 'No trial yet. The next client edit request will show here.',
  'Pas de plan': 'No plan',
  'attend le patron': 'waits for the owner',
  'Aucune modification': 'No change',
  'Pour le patron': 'For the owner',
  'pas de page': 'no page',
  'page vide': 'empty page',
  'texte': 'text',
  'sans photo': 'no photo',
  'Juste': 'Right',
  'En partie': 'Partly',
  'Faux': 'Wrong',
  'rejoué': 'replayed',
  'en direct': 'live',
  'échec': 'failed',
  'vérifié par Claude': 'checked by Claude',
  'Claude a vu un problème': 'Claude saw a problem',
  'essai(s)': 'round(s)',
  'Ouvrir la conversation': 'Open chat',
  'Ce que le client a demandé': 'What the client asked',
  'Ce qui a vraiment été fait (Qwen)': 'What really happened (Qwen)',
  'Ce que Claude aurait fait': 'What Claude would have done',
  'Pages changées par Claude (avant → après)': 'Pages Claude changed (before → after)',
  'Ce qui manque ou ce qui est faux (facultatif)': 'What is missing or wrong (optional)',
};
export default m;
